<div class="container">
  <div class="img-wrapper">
    <div class="arrow-wrapper">
      <div class="arrow previous" (click)="previous()">
        <img src="../../../assets/Preview/next.svg" alt="close" [hidden]="isFirstPreview()">
      </div>
      <div class="picture">
        <img [src]="currentPicture.path" alt="image" [hidden]="!currentPicture.loaded"
             (load)="currentPicture.loaded = true; showPicture();">
        <div [style.height]="currentPicture.height + 'px'" [style.width]="currentPicture.width + 'px'"
             *ngIf="!currentPicture.loaded">
          <app-picture-loading>
          </app-picture-loading>
        </div>
      </div>
      <div class="arrow" (click)="next()">
        <img src="../../../assets/Preview/next.svg" alt="close" [hidden]="isLastPreview()">
      </div>
    </div>
    <div class="picture-legend">
      <p>{{currentPicture.displayName}}</p>
      <span>{{getIndexLegend()}}</span>
    </div>
  </div>
  <div class="close" (click)="close()">
    <img src="../../../assets/Preview/close.svg" alt="close">
  </div>
</div>
